import React from 'react';
import { Copy, Help, Loading, Paging, SystemText } from '@salesperformanceint/e4shared';
import { useSelector } from 'react-redux';
import { apiGet } from 'services';
import Search from './components/search';

export const GTMBuddy = ({ assets, allowMultiple, onAdd, competencies }) => {
    const [results, setResults] = React.useState([]);
    const [items, setItems] = React.useState(assets);
    const [page, setPage] = React.useState(1);
    const [defaultSearch, setDefaultSearch] = React.useState('');
    const [defaultCompetencyIds, setDefaultCompetencyIds] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [doneSearch, setDoneSearch] = React.useState(false);
    const user = useSelector(state => state.user.user);

    const pageSize = 5;

    const runSearch = (search, competencyIds = []) => {
        setLoading(true);
        setDefaultSearch(search);
        setDefaultCompetencyIds(competencyIds);

        const tags = competencies
            .filter(c => c.tags && competencyIds.some(id => id === c.id))
            .reduce((a, c) => {
                return a.concat(c.tags);
            }, []);
        const uniqueTags = [...new Set(tags)];

        apiGet(
            `integrations/gtm?search=${search}&tags=${uniqueTags}`,
            user.guid,
            response => {
                setPage(1);
                setDoneSearch(true);
                setLoading(false);
                setResults(response);
            },
            err => {
                console.error(err);
                setLoading(false);
            }
        );
    };

    React.useEffect(() => {
        runSearch('');
    }, []);

    React.useEffect(() => {
        items && onAdd(items, 'gtm');
    }, [items]);

    const addItem = add => {
        if (allowMultiple) {
            if (!items.some(i => i.internal_Id === add.course_Id)) {
                setItems(items.concat([{ ...add, name: add.title, url: add.url, internal_Id: add.course_Id }]));
            }
        } else {
            setItems([{ ...add, name: add.title, url: add.url, internal_Id: add.course_Id }]);
        }
    };

    const removeItem = remove => {
        setItems(items.filter(i => i.internal_Id !== remove.internal_Id));
    };

    if (loading) return <Loading />;

    const start = (page - 1) * pageSize;
    const end = start + pageSize - 1;

    const Card = ({ result }) => {
        return (
            <div
                key={`${result._Id}`}
                data-testid="card-add"
                className="flex flex-centerx mb10 pitch-card pointer"
                onClick={() =>
                    addItem({
                        ...result,
                        source: 'gtm',
                        id: result.course_Id,
                        internal_Id: result.course_Id,
                        name: result.title,
                        company_Id: undefined,
                    })
                }
            >
                <div className="mt2">
                    <i className="fa fa-graduation-cap" />
                </div>
                <div className="flex-grow ml10">
                    <label>{result.title} </label>
                    {result.description && (
                        <div className="text-sm">
                            <Copy value={result.description} />
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const noResult = SystemText('Admin/Forms/FilePicker/GTMBuddy/NoResults');

    return (
        <div className="">
            <Search
                runSearch={runSearch}
                defaultSearch={defaultSearch}
                competencies={competencies}
                defaultCompetencyIds={defaultCompetencyIds}
            />
            {results.length === 0 && doneSearch && <div>{noResult}</div>}
            {results.length > 0 && (
                <div>
                    <div>
                        <label>{SystemText('Admin/Forms/FilePicker/GTMBuddy/Results')}</label>
                        <span className="text-sm ml10">({SystemText('Admin/Forms/FilePicker/GTMBuddy/Click')})</span>
                    </div>
                    <div className="list">
                        {results.map((t, i) => (i < start || i > end ? null : <Card key={`card-${i}`} result={t} />))}
                    </div>
                    {results.length > 0 && (
                        <Paging
                            pageSize={pageSize}
                            recordCount={results.length}
                            page={page}
                            goToPage={page => setPage(page)}
                        />
                    )}
                </div>
            )}
            {items.length > 0 && (
                <div className="mt20">
                    <label>{SystemText('Admin/Forms/FilePicker/GTMBuddy/SelectedLessons')}</label>
                    {items
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((u, i) => {
                            return (
                                <div key={`file-${i}`} className="mb5 flex flex-center">
                                    <i className={`fa fa-graduation-cap mr5`} />
                                    <span className="ellipsis500 flex-grow">{u.name}</span>
                                    <i
                                        className="ml5 text-danger fa fa-trash pointer text-right"
                                        data-testid="button-remove"
                                        title={SystemText('Admin/Forms/FilePicker/GTMBuddy/Remove', u.name)}
                                        onClick={() => removeItem(u)}
                                    />
                                </div>
                            );
                        })}
                </div>
            )}
        </div>
    );
};

export default GTMBuddy;
